$(document).ready(function () {
  if ($(".e-accordion").length > 0) {
    // scope of current accordion
    $(document)
      .find(".e-accordion")
      .each(function (e) {
        // clicking on accordion-toggle
        var accordionTriggers = $(this).find(".e-accordion-item__tease");

        accordionTriggers.on("click", function (e) {
          ToggleAccordionItem($(this));
        });
      });
  }

  var params = new URLSearchParams(window.location.search);

  if (params.get("id")) {
    let item = $(
      ".e-accordion-item[data-id=" +
        params.get("id") +
        "] .e-accordion-item__tease"
    );

    $("html, body").animate({
      scrollTop: parseInt($(item).offset().top),
    });

    ToggleAccordionItem(item);
  }

  function ToggleAccordionItem(item) {
    //Expand or collapse this panel
    if ($(item).hasClass("open")) {
      $(item).removeClass("open");
      $(item)
        .children(".e-accordion-item__tease .e-accordion-arrow")
        .removeClass("open");
      $(item).siblings(".e-accordion-item__content-wrapper").slideUp("fast");
    } else {
      $(item).addClass("open");
      $(item)
        .children(".e-accordion-item__tease .e-accordion-arrow")
        .addClass("open");
      $(item).siblings(".e-accordion-item__content-wrapper").slideDown("fast");
    }
  }


  $(".e-accordion__expand").on("click", function (e) {
    console.log("expand");

    var siblings = $(this).siblings(".e-accordion-item");

    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).text("Expand All");

      siblings.each(function (e) {
        $(this).find(".e-accordion-arrow").removeClass("open");
        $(this).children(".e-accordion-item__tease").removeClass("open");
        $(this).children(".e-accordion-item__content-wrapper").slideUp("fast");
      });
      //each
    } else {
      $(this).addClass("open");
      $(this).text("Collapse All");

      siblings.each(function (e) {
        $(this).find(".e-accordion-arrow").addClass("open");
        $(this)
          .children(".e-accordion-item__tease")
          .addClass("open");
        $(this)
          .children(".e-accordion-item__content-wrapper")
          .slideDown("fast");
        $(this);
      });
      //each
    }
  });

});
